import {
  Card,
  CardProps,
  SquareNewWindowIcon,
  Typography,
} from "@codat/orchard-ui";
import React from "react";

import Button from "components/Button";

import styles from "./GettingStartedCard.module.scss";

export interface GettingStartedCardProps extends CardProps {
  headerIcon: React.ReactNode;
  headerText: string;
  description: string;
  buttonName: string;
  newWindowIcon?: boolean;
  linkToNavigate: string;
  isInternalLink?: boolean;
  testId: string;
}

export const GettingStartedCard = ({
  headerIcon,
  headerText,
  description,
  buttonName,
  newWindowIcon,
  linkToNavigate,
  isInternalLink,
  testId,
}: GettingStartedCardProps) => {
  return (
    <Card
      data-testid={testId}
      size="small"
      className={styles.gettingStartedCard}
    >
      <div>
        <div className={styles.header}>
          <div className={styles.headerIcon}>{headerIcon}</div>
          <Typography as="h4" variant="heading_sm">
            {headerText}
          </Typography>
        </div>

        <Typography as="p" variant="body_sm" className={styles.description}>
          {description}
        </Typography>
      </div>

      <Button
        buttonName={buttonName}
        variant="secondary"
        color="action"
        size="small"
        href={isInternalLink ? undefined : linkToNavigate}
        target={isInternalLink ? undefined : "_blank"}
        to={isInternalLink ? linkToNavigate : undefined}
        data-testid="info-button"
      >
        {buttonName}
        {newWindowIcon && (
          <SquareNewWindowIcon
            className={styles.buttonIcon}
            data-testid="external-icon"
          />
        )}
      </Button>
    </Card>
  );
};
